import React,{useState,useEffect} from 'react'
import axios from 'axios'

const Blog = () => {
    const [blogs,setBlogs] = useState([])
    useEffect(()=>{
        const fetchBlog = async()=>{
            const res = await axios.get('https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@devanshi0608')
            setBlogs(res.data.items)
            console.log(blogs)
        }
        fetchBlog()
    },[])
    return (
        <section id="blog" style={{backgroundColor:"white"}}>
        <div>
          {blogs.map(post=>(
               <div className="card" style={{width:"60vw",marginLeft:"auto",marginRight:"auto"}}>
               <img src = {post.thumbnail} className = "Img"/>
               <h1 className = "cardHeader">{post.title}</h1>
               <p className = "cardText">Posted on: {post.pubDate}</p>
               <a href = {post.link} className = "btn btn-secondary"> Read the Full Blog Here!</a>
               </div> 
          ))}
        </div>
        </section>
    )
}

export default Blog
